export default __webpack_public_path__ + "979efc2.png";